import { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import {Menu, X} from 'lucide-react'

const navItems = [
  { to: '/', label: 'Home' },
  { to: '/calculator', label: 'Praxis Core Calculator' },
  { to: '/blog', label: 'Math Computation Blog' },
  { to: '/about', label: 'About Us' },
]

export default function Header() {
  const [open, setOpen] = useState(false)

  return (
    <header className="sticky top-0 z-50 bg-[#FAFAF7]/85 backdrop-blur-md border-b-2 border-[#0A0A0A]">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group">
          <div className="w-8 h-8 bg-[#0A0A0A] flex items-center justify-center text-[#FAFAF7] font-mono font-bold text-sm group-hover:bg-[#E63946] transition-colors">
            =
          </div>
          <span className="font-extrabold tracking-tight text-[15px]">
            CalculatorSkills<span className="text-[#E63946]">.com</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `px-3.5 py-2 text-[13px] font-medium tracking-tight transition-colors ${
                  isActive
                    ? 'text-[#0A0A0A] bg-[#0A0A0A]/5'
                    : 'text-[#475569] hover:text-[#0A0A0A]'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <Link to="/calculator" className="hidden lg:inline-flex btn-primary !py-2 !px-4 !text-[13px]">
          Try Calculator →
        </Link>

        <button
          aria-label="Toggle menu"
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t-2 border-[#0A0A0A] bg-[#FAFAF7]">
          <nav className="px-6 py-4 flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2.5 text-sm font-medium ${
                    isActive ? 'text-[#0A0A0A] bg-[#0A0A0A]/5' : 'text-[#475569]'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/calculator"
              onClick={() => setOpen(false)}
              className="btn-primary mt-3 justify-center"
            >
              Try Calculator
            </Link>
          </nav>
        </div>
      )}
    </header>
  )
}
